// extracted by mini-css-extract-plugin
export default {"updateBanner":"@gscope-mfe-common-components__src-components-UpdateBanner-___index-module__updateBanner___ZOG2B"};